import { signal } from "@preact/signals-react";

const currentCourse = new signal();

export { currentCourse };
